module.exports = __webpack_public_path__ + "img/no2.f2237e4d.svg";